import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type { ImageProps } from '@wix/thunderbolt-components-native';

import type {
  FlashComponentDefinition,
  FlashComponentProps,
} from '../FlashComponent.types';

const props = withCompInfo<FlashComponentProps, FlashComponentDefinition>()(
  ['compData', 'compProps', 'topology', 'experiments'],
  ({ compData, compProps, topology, experiments }) => {
    const { uri, placeHolderImage } = compData;
    const placeholderImage: Partial<ImageProps> = { ...placeHolderImage };
    placeholderImage.displayMode =
      compProps.displayMode === 'stretch' ? 'fill' : 'fit';

    const shouldResolveLinksInPlace = Boolean(
      experiments['specs.thunderbolt.resolveLinksInPlace'],
    );

    return {
      uri: uri ? `${topology.mediaRootUrl}media/${uri}` : undefined,
      placeholderImage,
      // TODO: Change when correct type is added to TB
      link:
        (shouldResolveLinksInPlace
          ? compData.link
          : (compData.link as any)?.resolvedLink) || null,
    };
  },
);

export default createComponentMapperModel({ props });
